import { Dialog } from "@rneui/themed";
import { StyleSheet, View } from "react-native";
import Text from "./text";
import translate from "libs/locale";
import { SCREEN_WIDTH, TABLET_PC } from "../libs/utils/constants";
import Input from "./input";

const ActionDialog = ({
  title = "",
  message,
  negativeText = translate("cancel"),
  positiveText = translate("ok"),
  negativeAction = null,
  positiveAction = null,
  visible = false,
  loading = false,
  style = {},
  placeholder,
  inputValue,
  onChangeText,
}: {
  title: string;
  message: string;
  negativeText?: string;
  positiveText?: string;
  negativeAction?: () => void;
  positiveAction?: () => void;
  visible: boolean;
  loading?: boolean;
  style?: any;
  placeholder?: string;
  inputValue?: string;
  onChangeText?: (text: string) => void;
}) => {
  return (
    <Dialog
      isVisible={visible}
      onBackdropPress={negativeAction}
      overlayStyle={[TABLET_PC && { maxWidth: 300 }, style]}
    >
      {!loading && (
        <Dialog.Title title={title} titleProps={{ style: styles.title }} />
      )}
      <View style={styles.row}>
        <Text style={styles.message}>{message}</Text>
        {loading && <Dialog.Loading />}
      </View>
      {onChangeText && (
        <Input
          containerStyle={styles.input}
          placeholder={placeholder}
          onChangeText={onChangeText}
          value={inputValue}
        />
      )}
      {!loading && (
        <Dialog.Actions>
          <Dialog.Button
            title={positiveText}
            onPress={positiveAction}
            titleProps={{ style: [styles.button] }}
          />
          <Dialog.Button
            title={negativeText}
            onPress={negativeAction}
            titleProps={{ style: [styles.button, styles.negativeButton] }}
          />
        </Dialog.Actions>
      )}
    </Dialog>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: "center",
    backgroundColor: "#00000080",
  },
  input: {
    marginVertical: 15,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    fontFamily: "MontserratBold",
    fontSize: 24,
    marginBottom: 10,
  },
  message: {
    color: "#636E72",
  },
  button: {
    fontFamily: "MontserratBold",
    fontSize: 12,
  },
  negativeButton: {
    opacity: 0.5,
    fontFamily: "Montserrat",
  },
});

export default ActionDialog;
